import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Layout from "layouts/layout";
import Table from "components/table/table";
import ListContainer from "components/list/list-container";
import ListHeader from "components/list/list-header";
import _ from "lodash";
import { Profile1 } from "constants/images";
import ActionIconBtn from "components/button/action-btn";
import EditPencilIconSVG from "assets/svg/edit-pencil-icon";
import moment from "moment";
import RoleDeleteModal from "components/roles/role-delete-modal";
import RoleHasMilestoneModal from "components/roles/role-has-milestone-modal";
import { useDialogHook } from "utils/customhooks";
import RoleAddModal from "components/roles/role-add-modal";
import { urlSerializer } from "utils/utils";
import ToolTip from "components/tooltip/tooltip";
import { HiMiniLanguage } from "react-icons/hi2";
import Modal from "components/global/modal";
import toast from "react-hot-toast";

import {
  REFRESH_ROLES,
  GET_ROLES,
  SET_ROLES,
} from "redux/modules/role-management/types";

export default function Roles() {
  const { http } = global.services;
  const {
    limit,
    page,
    roles = [],
    initialize,
    refresh,
    loadMore,
    isRequesting,
    pages = [],
  } = useSelector((state) => state.role);
  const query = useQuery();
  const searchValue = query.get("search");
  const [filterValue, setFilterValue] = useState(searchValue);
  const [selectedRows, setSelectedRows] = useState([]);
  const modal = useDialogHook(RoleAddModal);
  const _delete = useDialogHook(RoleDeleteModal);
  const _hasMilestone = useDialogHook(RoleHasMilestoneModal);
  const dispatch = useDispatch();
  const [showTranslate,setShowTranslate] = useState(false);
  

  const getRoles = async (selectedPage = null) => {
    if (isRequesting || !loadMore) return;

    dispatch({ type: GET_ROLES, payload: [] });

    try {
      const url = urlSerializer("roles/list", {
        search: filterValue,
        page: selectedPage ?? page,
        limit: limit,
      });
      const { data } = await http.get(url);
      const _loadMore = data.data.length > 0 ? true : false;
      const _page = data.current_page;
      const _lastPage = data.last_page;

      dispatch({
        type: SET_ROLES,
        payload: {
          data: data.data,
          loadMore: _loadMore,
          page: _page,
          lastPage: _lastPage,
        },
      });
    } catch (err) {
      console.log("error@getRoles", err);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();

    dispatch({
      type: REFRESH_ROLES,
      payload: [],
    });
  };

  const handleAddEdit = (data = {}) => {
    modal(data, (result) => {
      if (!_.isEmpty(result)) {
        if (result === "add") {
          dispatch({
            type: REFRESH_ROLES,
            payload: [],
          });
        } else if (result === "delete") {
          handleDelete(data);
        }
      }
    });
  };

  const translateName = async(data = {})=>{
      try{
        setShowTranslate(true);
        const url = urlSerializer(`roles/translate/${data.id}`);
        const result = await http.put(url);
        if(result?.data?.success){
          toast.success('Successfully updated');
          dispatch({
            type: REFRESH_ROLES,
            payload: [],
          });
        }
      }catch(e){
        console.error(e);
        toast.error('Something went wrong');
      }finally{
        setShowTranslate(false)
      }
    }
  
    const TranslateLoading = ()=>{
      return (
  
        <Modal
          width="w-19/20 md:w-16/20 2md:w-12/20 3md:w-8/20 1xl:w-6/20"
          contentClassName="rounded-lg overflow-auto custom-scroll"
          wrapperClassName="overflow-visible"
          footerClass="border-t border-mutedGray"
        >
          <div className="w-full">
            {/* content */}
            <div className="pl-10 pr-7 py-7">
              <p className="text-lightBlack font-bold text-center">
                Translate ...
              </p>
            </div>
          </div>
        </Modal>
      )
    }

  const handleDelete = async (data = {}) => {
    const url = urlSerializer(`roles/check/${data.id}`);
    const result = await http.get(url);
    const has_milestones = result.data.has_milestones;
    if (has_milestones) {
      _hasMilestone(result.data, (result) => {

      });
    } else {
      _delete(data, (result) => {
        if (!_.isEmpty(result)) {
          console.log("result ", result);
          if (result === "delete") {
            dispatch({
              type: REFRESH_ROLES,
              payload: [],
            });
          }
        }
      });
    }
  };

  const columns = [
    {
      title: "Role Title",
      dataIndex: "name",
      nowrap: true,
      key: "name",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.name ? (
            <>
              {/* <img
                src={Profile1}
                alt="account"
                className="account-img mr-2.5"
              /> */}
              <p>{record.name}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "English",
      dataIndex: "en",
      nowrap: true,
      key: "en",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.en ? (
            <>
              <p>{record.en}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },{
      title: "Arabic",
      dataIndex: "ar",
      nowrap: true,
      key: "ar",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.ar ? (
            <>
              <p>{record.ar}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "Bengali",
      dataIndex: "bn",
      nowrap: true,
      key: "bn",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.bn ? (
            <>
              <p>{record.bn}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "Chinese",
      dataIndex: "ch",
      nowrap: true,
      key: "ch",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.ch ? (
            <>
              <p>{record.ch}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "Frence",
      dataIndex: "fr",
      nowrap: true,
      key: "fr",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.fr ? (
            <>
              <p>{record.fr}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "Hindi",
      dataIndex: "hi",
      nowrap: true,
      key: "hi",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.hi ? (
            <>
              <p>{record.hi}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "Spanish",
      dataIndex: "es",
      nowrap: true,
      key: "es",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.es ? (
            <>
              <p>{record.es}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "Portugues",
      dataIndex: "pt",
      nowrap: true,
      key: "pt",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.pt ? (
            <>
              <p>{record.pt}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "Russian",
      dataIndex: "ru",
      nowrap: true,
      key: "ru",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.ru ? (
            <>
              <p>{record.ru}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "Urdu",
      dataIndex: "ur",
      nowrap: true,
      key: "ur",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.ur ? (
            <>
              <p>{record.ur}</p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    // {
    //   title: "Date Created",
    //   dataIndex: "created_at",
    //   nowrap: true,
    //   key: "dateCreated",
    //   render: (record) => (
    //     <p>{moment(record.created_at).format("MMMM DD, YYYY")}</p>
    //   ),
    // },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      hideSorting: true,
      nowrap: true,
      render: (record) => (
        <div className="flex space-x-4">
          <ToolTip
            value={`Translate`}
            backgroundColor="#0c6ed1"
            color="white"
            width='97px'
            >
            <ActionIconBtn
              className="action-btn-round"
              icon={<HiMiniLanguage  className="m-auto" />}
              onClick={() => translateName(record)}
            />
          </ToolTip>
          <ToolTip
            value={`Edit Role`}
            backgroundColor="#0c6ed1"
            color="white"
            width='97px'
            >
            <ActionIconBtn
              className="action-btn-round"
              icon={<EditPencilIconSVG className="m-auto" />}
              onClick={() => handleAddEdit(record)}
            />
          </ToolTip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (initialize) getRoles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, initialize]);

  return (
    <Layout title="Roles" routeName="roles">
      {
        showTranslate &&
        <TranslateLoading/>
      }
      <div className="main-page-wrapper">
        <ListContainer
          header={
            <ListHeader
              title="List"
              countValue={_.size(roles)}
              filterValue={filterValue}
              setFilterValue={setFilterValue}
              buttonName="+ Add Role"
              showAddButton={true}
              onClickButton={() => handleAddEdit()}
              onSearch={(e) => handleSearch(e)}
            />
          }
        >
          <Table
            columns={columns}
            dataSource={roles}
            pagination={true}
            selectable={true}
            selected={selectedRows}
            onSelected={(selectedRows) => {
              setSelectedRows(selectedRows);
            }}
            perPage={10}
            currentPage={page}
            onHandleChangePage={getRoles}
            pages={pages}
          />
        </ListContainer>
      </div>
    </Layout>
  );
}

const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};
